import { useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import IconShorting from "../SvgIcons/IconShorting";
import CustomDropdown from "../CustomDropdown";
import { Button } from "primereact/button";
import utils from "../../utils/utils";

export default function DateFilter({ onPeriodSelect = () => { }, showDateFilter }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [direction, setDirection] = useState('inbound');
  const [callStatus, setCallStatus] = useState('');
  const [dateRange, setDateRange] = useState([]);
  const directionList = [{ label: 'Select', value: '' }, { label: 'All', value: 'all' }, { label: 'incoming', value: 'inbound' }, { label: 'outgoing', value: 'outbound' }];
  const callStatusList = [{ label: 'Select', value: '' }, { label: 'All', value: 'all' }, { label: 'Answered', value: 'answered' }, { label: 'Missed', value: 'missed' }];
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // Handle range change (for custom date range)
  const handleRangeChange = (item) => {
    setRange([item.selection]);
    setSelectedPeriod("Custom");
    const { startDate, endDate } = item.selection;
    setDateRange([startDate, endDate])
    if (startDate && endDate && !showDateFilter) {
      onPeriodSelect("Custom", startDate, endDate);
    }
  };

  const applyFilter = () => {
    console.log(callStatus, direction, dateRange);
    let obj = {
      status: callStatus,
      direction: direction,
      startDate: dateRange?.length > 0 ? utils.formatDate(dateRange[0]) : '',
      endDate: dateRange?.length > 0 ? utils.formatDate(dateRange[1]) : ''
    }
    onPeriodSelect(obj);
    setIsDropdownOpen(false);
  }

  // Handle predefined period button click
const handleSelect = (period) => {
  setSelectedPeriod(period);
  // setIsDropdownOpen(false);  // Keep dropdown open if you want

  const today = new Date();
  let startDate = new Date(today.getTime());
  let endDate = new Date(today.getTime());

  switch (period) {
    case "Today":
      // startDate and endDate both today (already set)
      break;

       case "This Week":
        startDate.setDate(today.getDate() - 6);
      break;

    case "Last Week":
      // Last week Sunday to Saturday
      const lastWeekEnd = new Date(today);
      // Last week's Saturday = last Sunday (today.getDay() = 0 Sunday) - 1
      lastWeekEnd.setDate(today.getDate() - today.getDay() - 1);
      const lastWeekStart = new Date(lastWeekEnd);
      lastWeekStart.setDate(lastWeekEnd.getDate() - 6);
      startDate = lastWeekStart;
      endDate = lastWeekEnd;
      break;

    case "This Week":
      startDate = new Date(today);
      startDate.setDate(today.getDate() - 6); // 6 days before today, total 7 days including today
      endDate = today;
      break;


      case "This Month":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = today;  // Always end at today, no matter what the date is
        break;

      case "Last Month":
        const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        startDate = lastMonth;
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

      case "Quarterly": {
        // Get the first day of this month
        const firstDayOfThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        // Go back 1 day to get the last day of the previous month
        const lastDayOfLastMonth = new Date(firstDayOfThisMonth - 1);
        // End date: last day of previous month
        endDate = lastDayOfLastMonth;
        // Start date: first day of the month, 2 months before endDate
        startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 2, 1);
        break;
      }

      case "Half Yearly": {
        // First day of this month
        const firstDayOfThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        // Last day of previous month
        const lastDayOfLastMonth = new Date(firstDayOfThisMonth - 1);
        // Start date = 5 months before the start of last month
        startDate = new Date(lastDayOfLastMonth.getFullYear(), lastDayOfLastMonth.getMonth() - 5, 1);
        endDate = lastDayOfLastMonth;
        break;
      }

      case "Yearly":
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = new Date(today.getFullYear(), 11, 31);
        break;

      default:
        break;
    }

    setRange([{ startDate, endDate, key: "selection" }]);
    setDateRange([startDate, endDate])
    if(!showDateFilter){
      onPeriodSelect(period, startDate, endDate);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".date-filter-dropdown")) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="date-filter-dropdown position-relative">
      <button
        type="button"
        className="tranparenteffect position-relative border-0 border-transparent bg-transparent"
        onClick={() => setIsDropdownOpen((open) => !open)}
      >
        <IconShorting />
      </button>

      <div className={`dateopen${isDropdownOpen ? " open" : ""}`} style={{ display: "block" }}>
        {showDateFilter && (<div style={{ marginTop: 15 }}>
          <div style={{ marginTop: 10 }}>
            <label style={{ fontWeight: 600, fontSize: 14, marginBottom: 5, color: '#000' }}>Call Type</label>
            <CustomDropdown
              name="direction"
              defaultClass='call-dropdown'
              options={directionList}
              value={direction.toString()}
              onChange={(value) => {
                console.log(value)
                setDirection(value);
              }}
              placeholder="Call Type"
              className="items-per-page-dropdown"
            />
          </div>
          <div style={{ marginTop: 10 }}>
            <label style={{ fontWeight: 600, fontSize: 14, marginBottom: 5, color: '#000' }}>Call Status</label>
            <CustomDropdown
              name="call_status"
              defaultClass='call-dropdown'
              options={callStatusList}
              value={callStatus}
              onChange={(value) => {
                console.log(value)
                setCallStatus(value);
              }}
              placeholder="Call Status"
              className="items-per-page-dropdown"
            />
          </div>
        </div>)}

        <div style={{ marginTop: 10 }}>
          {/* Quick Select Period Buttons */}
          <div style={{ display: "flex", flexDirection: "row-reverse", gap: "10px" }}>
            <div className="datefiltermain">
              {[
                "Today",
                "This Week",
                "Last Week",
                "This Month",
                "Last Month",
                "Quarterly",
                "Half Yearly",
                "Yearly",
              ].map((period) => (
                <button
                  key={period}
                  type="button"
                  className={`dropdown-days ${selectedPeriod === period ? "selected" : ""}`}
                  onClick={() => handleSelect(period)}
                  onMouseDown={(e) => e.preventDefault()} // prevents losing focus
                >
                  {period}
                </button>
              ))}
            </div>

            {/* Calendar Range Picker */}
            <DateRange
              editableDateInputs={false}
              onChange={handleRangeChange}
              moveRangeOnFirstSelection={false}
              ranges={range}
              maxDate={new Date()}
              locale={enUS}
              showPreview={false}
              showDateDisplay={true}
              dateDisplayFormat="MM/dd/yyyy"
              className="customcalender"
            />
          </div>

          {/* Apply Filter Button */}
          {showDateFilter && (
            <Button
              style={{ marginTop: 10 }}
              label="Apply Filter"
              onClick={applyFilter}
            />
          )}
        </div>

      </div>
    </div>
  );
}
